// utils/api.js
import { APP_CONFIG } from '../config/appConfig';
let isRedirecting = false;
export const apiClient = async (endpoint, options = {}) => {
  const token = localStorage.getItem('token');
  
  // ✅ Vérifier que le token existe
   if (!token) {
     if (!isRedirecting) {
       isRedirecting = true;
       window.location.replace('/login');
     }
     throw new Error('Token manquant');
   }
  
  // Construction de l'URL
  const url = `${APP_CONFIG.BASE_URL}${endpoint}`;
	
  const defaultHeaders = {
     'Content-Type': 'application/json',
     'Authorization': `Bearer ${token}`
   };
  
  try {
	console.log(`🔵 API Request: ${url}`);
      const response = await fetch(url, {
      ...options,
      headers: {
        ...defaultHeaders,
        ...options.headers
      }
    });

	 
	// ✅ Si 401 Unauthorized, rediriger vers login
	if (response.status === 401) {
	      if (!isRedirecting) {
	        isRedirecting = true;
	        localStorage.removeItem('token');
	        localStorage.removeItem('user');
	        window.location.replace('/login');
	      }
	      throw new Error('Non autorisé');
	}
	
	// ✅ Si 404 Not Found, retourner un tableau vide (ne pas rediriger)
	if (response.status === 404) {
	     console.warn(`⚠️ Endpoint ${endpoint} non trouvé (404)`);
	     return [];
	}
	   
    // Si la réponse est HTML (page de login), la session a expiré
    const contentType = response.headers.get('content-type');
	
	// ✅ Vérifier que la réponse est JSON
	if (contentType && contentType.includes('application/json')) {
	     const data = await response.json();
	     
	     if (!response.ok) {
	       throw new Error(data.error || `HTTP ${response.status}`);
	     }
	     
	     return data;
	}
	
	// ✅ Si la réponse n'est pas JSON, retourner un tableau vide
	console.warn('⚠️ Réponse non-JSON reçue:', contentType);
	return [];

	
   
    
    return await response.json();
  } catch (error) {
    console.error("API Error:", error);
    return [];
  }
};

// Réinitialiser le flag après redirection
window.addEventListener('load', () => {
  isRedirecting = false;
});